export function isGreaterSkill(skillId: string): boolean {
  if (!skillId) {
    return false;
  }
  return skillId.startsWith('greater_') || skillId.includes('_greater_');
}

export function appendGreaterBadge(container: HTMLElement): void {
  const badgeEl = document.createElement('span');
  badgeEl.className = 'overlay-plus';
  badgeEl.textContent = '+';
  container.appendChild(badgeEl);
}

export function createSkillEmojiBox(emoji: string, showGreaterBadge: boolean): HTMLDivElement {
  const boxEl = document.createElement('div');
  boxEl.className = 'skill-emoji-box';

  const emojiEl = document.createElement('span');
  emojiEl.className = 'emoji';
  emojiEl.textContent = emoji;
  boxEl.appendChild(emojiEl);

  if (showGreaterBadge) {
    appendGreaterBadge(boxEl);
  }

  return boxEl;
}
